export const GET_GOOD_SERVICES_HEAD_MASTER_LIST = "GET_GOOD_SERVICES_HEAD_MASTER_LIST"
export const GET_GOOD_SERVICES_HEAD_MASTER_LIST_SUCCESS = "GET_GOOD_SERVICES_HEAD_MASTER_LIST_SUCCESS"
export const GET_GOOD_SERVICES_HEAD_MASTER_LIST_FAIL = "GET_GOOD_SERVICES_HEAD_MASTER_LIST_FAIL"

export const GET_GOOD_SERVICES_HEAD_MASTER_DETAIL = "GET_GOOD_SERVICES_HEAD_MASTER_DETAIL"
export const GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_SUCCESS = "GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_SUCCESS"
export const GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_FAIL = "GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_FAIL"

export const ADD_NEW_GOOD_SERVICES_HEAD_MASTER = "ADD_NEW_GOOD_SERVICES_HEAD_MASTER"
export const ADD_NEW_GOOD_SERVICES_HEAD_MASTER_SUCCESS = "ADD_NEW_GOOD_SERVICES_HEAD_MASTER_SUCCESS"
export const ADD_NEW_GOOD_SERVICES_HEAD_MASTER_FAIL = "ADD_NEW_GOOD_SERVICES_HEAD_MASTER_FAIL"

export const UPDATE_GOOD_SERVICES_HEAD_MASTER = "UPDATE_GOOD_SERVICES_HEAD_MASTER"
export const UPDATE_GOOD_SERVICES_HEAD_MASTER_SUCCESS = "UPDATE_GOOD_SERVICES_HEAD_MASTER_SUCCESS"
export const UPDATE_GOOD_SERVICES_HEAD_MASTER_FAIL = "UPDATE_GOOD_SERVICES_HEAD_MASTER_FAIL"

export const DELETE_GOOD_SERVICES_HEAD_MASTER = "DELETE_GOOD_SERVICES_HEAD_MASTER"
export const DELETE_GOOD_SERVICES_HEAD_MASTER_SUCCESS = "DELETE_GOOD_SERVICES_HEAD_MASTER_SUCCESS"
export const DELETE_GOOD_SERVICES_HEAD_MASTER_FAIL = "DELETE_GOOD_SERVICES_HEAD_MASTER_FAIL"
